import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Tenant } from 'src/app/shared/models';
import { ExceptionService, PaginatedList, UtilsService } from 'src/app/xform-compat';

/**
 * Data service to handle system settings
 */
@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private url = '/api/rms/tenants';

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private exceptionService: ExceptionService
  ) { }

  /**
   * Gets the list of tenants
   * @returns {Observable<PaginatedList<ExchangeItem>>}: Paginated list with the exchanges
   */
  public getRecords (params?: any): Observable<PaginatedList<Tenant>> {
    const httpParams: HttpParams = this.utilsService.generateParams(params);
    return this.http.get(this.url, {params: httpParams}).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
